import React from 'react';
import './Header.css';
import Logo from '../components/assets/images/icon-logo.png'
import { Link } from 'react-router-dom';
import { FaFacebookF, FaWhatsapp, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";

function Header() {
  return (
    <div>
      <header className="header">
        {/* Top bar-------------- */}
        <div className="top-bar">
          <div className="contact-info">
            <span className="icon-phone"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
            </svg>
              +91 -------------</span>
          </div>
          <div className="tagline">Free Shipping + Extra 5% OFF on Prepaid Order</div>

          <div className="offer-button-wrapper">
            <button className="shilajit-offer-btn">
              3 Shilajit at ₹999
            </button>
          </div>
        </div>
        {/* Main header-------------------- */}
      </header>
      <header className="header-nav">
        <div className="top-bar-nav">
        <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://wa.me/919999999999" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaLinkedin/></a>

          </div>
          <div className="logo-1">
            <img src={Logo} alt="Logo-1" />
          </div>

          <div className="right-icons">
            <Link to="/login" className="login">LOGIN / REGISTER</Link> | <Link to="/cart" className="price">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                strokeWidth={1.5} stroke="currentColor" className="size-7">
                <path strokeLinecap="round" strokeLinejoin="round"
                  d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 
         1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 
         1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 
         5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 
         10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 
         0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
              </svg>
            </Link>|
            <a href="/wishlist">
              <span className="cart-count">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                </svg>
              </span>
            </a>
         
          
          </div>
        </div>
      </header>
    </div>

  );
}

export default Header;